export default "__VITE_ASSET__BUfiiBbf__"